import type { MessageKey } from 'types/LocaleMessageKey';

import { MESSAGE_SUCCESS_DEFAULT } from '@/app/[locale]/store/_consts/discounts';
import type { DiscountContextValues } from '@/app/[locale]/store/_contexts/DiscountProvider';

import _getUrlDiscountMessage from './_getUrlDiscountMessage';
import type { DiscountError, UiDiscount } from './types';

interface GetDiscountAppliedMessage
  extends Pick<
    DiscountContextValues,
    'appliedDiscountCode' | 'promotionCodes'
  > {
  campaign: string | null | undefined;
  discountError: DiscountError;
  errorCode: string | null | undefined;
  errorMessage: MessageKey | null;
  reason: string | null | undefined;
  showHighestDiscountEyebrow: boolean | undefined;
  showUrlDiscount: boolean;
  statsigDiscountArray: UiDiscount[];
}

// this is where we determine what discount message (Phrase string) to show
export const _getDiscountAppliedMessage = ({
  appliedDiscountCode,
  campaign,
  errorCode,
  errorMessage,
  discountError,
  showHighestDiscountEyebrow,
  promotionCodes,
  reason,
  showUrlDiscount,
  statsigDiscountArray,
}: GetDiscountAppliedMessage): MessageKey | null => {
  const defaultMessage = appliedDiscountCode ? MESSAGE_SUCCESS_DEFAULT : null;
  const discountFound = statsigDiscountArray.find(
    (discountedObj) => discountedObj.discountCode === appliedDiscountCode,
  );
  const campaignFound = statsigDiscountArray.find(
    (discountedObj) => discountedObj.discountCode === campaign,
  );

  const urlDiscountMessage = _getUrlDiscountMessage({
    campaign,
    campaignFound,
    defaultMessage,
    discountError,
    discountFound,
    errorCode,
    errorMessage,
    promotionCodes,
    reason,
    showHighestDiscountEyebrow,
    showUrlDiscount,
  });
  if (urlDiscountMessage) return urlDiscountMessage;

  return null;
};
